import { Controller } from '@hotwired/stimulus'
import { FetchRequest } from '@rails/request.js'
import Cookies from 'js-cookie'

export default class extends Controller {
  static targets = ["input", "results"]

  async triggerSearch() {
    const query = this.inputTarget.value
    if (!query) {
      this.clearResults();
      return;
    }

    const request = new FetchRequest('GET', `/customers/search?q=${query}`, { responseKind: 'json' })
    const response = await request.perform()

    if (response.ok) {
      const customers = await response.json
      this.displayResults(customers)
    } else {
      this.displayError()
    }
  }

  displayResults(customers) {
    if (customers.length === 0) {
      this.resultsTarget.innerHTML = `<div class="p-2 text-sm text-gray-500">No customers found</div>`;
      return;
    }

    this.resultsTarget.innerHTML = customers.map(customer =>
      `<div class="p-2 hover:bg-gray-100 cursor-pointer" data-action="click->customer-search#selectCustomer" data-customer-id="${customer.id}">
        ${customer.first_name} ${customer.last_name} - ${customer.email} - ${customer.phone_number}
      </div>`
    ).join('');

    this.resultsTarget.classList.remove('hidden')
  }

  selectCustomer(event) {
    const customerId = event.currentTarget.dataset.customerId;

    this.inputTarget.value = event.currentTarget.textContent.trim();
    this.clearResults();

    Cookies.set('selected_customer_id', customerId);

    this.resultsTarget.classList.add('hidden');
  }

  clearResults() {
    this.resultsTarget.innerHTML = ''
  }

  displayError() {
    this.resultsTarget.innerHTML = `<div class="p-2 text-sm text-red-500">Error loading customers</div>`;
  }
}
